import { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Stack, Typography } from "@mui/material"
import HelpIcon from '@mui/icons-material/Help';
import CloseIcon from '@mui/icons-material/Close';
import { BiSortAlt2 } from "react-icons/bi";
import BaseButton from "../BaseButton"
import BaseCheckbox from "../BaseCheckbox";

import { setMedicationFilterOptions } from "../../store";

const MedicationSortForm = ({ sx, onClose }) => {
  const dispatch = useDispatch()
  const resFilterOptions = useSelector(state => state.medicationFilterOptions)

  const [guidanceLevelSortDir, setGuidanceLevelSortDir] = useState()
  const [alphabetSortDir, setAlphabetSortDir] = useState()

  useMemo(() => {
    setGuidanceLevelSortDir(resFilterOptions?.guidanceLevelSortDir)
    setAlphabetSortDir(resFilterOptions?.alphabetSortDir)
  }, [resFilterOptions])

  const handleClickFilter = () => {
    const options = {
      ...resFilterOptions,
      guidanceLevelSortDir: guidanceLevelSortDir,
      alphabetSortDir
    }
    dispatch(setMedicationFilterOptions(options))
    onClose()
  }

  const handleResetFilter = () => {
    dispatch(setMedicationFilterOptions({
      ...resFilterOptions,
      guidanceLevelSortDir: null,
      alphabetSortDir: null
    }))
    onClose()
  }

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '350px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        ...sx
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: 'primary.mainBlue'
          }}
        >
          <BiSortAlt2
           size='20px'
          />
          <Typography
            variant="h4"
            color="primary.black"
            sx={{
              ml: '4px'
            }}
          >
            Sort By
          </Typography>
        </Box>
        <CloseIcon
          sx={{
            fontSize: '24px',
            color: 'primary.mediumGray',
            cursor: 'pointer'
          }}
          onClick={onClose}
        />
      </Box>
      <Stack
        spacing={'32px'}
        mt='32px'
      >
        <Box>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: '18px'
          }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }}>
              <Typography variant='h4' color='primary.darkGray'>
                Risk factor level
              </Typography>
              <HelpIcon 
                sx={{
                  color: 'primary.mediumGray',
                  fontSize: '20px',
                  ml: '8px'
                }}
              />
            </Box>
            <Box
              sx={{
                cursor: 'pointer',
              }}
              onClick={() => setGuidanceLevelSortDir(null)}
            >
              <Typography variant='body' color='primary.mainBlue'>
                Clear
              </Typography>
            </Box>
          </Box>
          <Stack direction={{ xs: 'row', md: 'row'}} spacing={{ xs: '4px', md: '12px' }}>
            <BaseCheckbox
              label='Hig to low'
              checked={guidanceLevelSortDir === 'desc'}
              onChange={() => setGuidanceLevelSortDir('desc')}
            />
            <BaseCheckbox
              label='Low to high'
              checked={guidanceLevelSortDir === 'asc'}
              onChange={() => setGuidanceLevelSortDir('asc')}
            />
          </Stack>
        </Box>
        <Box>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: '18px'
          }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }}>
              <Typography variant='h4' color='primary.darkGray'>
                Alphabetical order
              </Typography>
              <HelpIcon 
                sx={{
                  color: 'primary.mediumGray',
                  fontSize: '20px',
                  ml: '8px'
                }}
              />
            </Box>
            <Box
              sx={{
                cursor: 'pointer',
              }}
              onClick={() => setAlphabetSortDir(null)}
            >
              <Typography variant='body' color='primary.mainBlue'>
                Clear
              </Typography>
            </Box>
          </Box>
          <Stack direction={{ xs: 'row', md: 'row'}} spacing={{ xs: '4px', md: '12px' }}>
            <BaseCheckbox
              label='A-Z'
              checked={alphabetSortDir === 'asc'}
              onChange={() => setAlphabetSortDir('asc')}
            />
            <BaseCheckbox
              label='Z-A'
              checked={alphabetSortDir === 'desc'}
              onChange={() => setAlphabetSortDir('desc')}
            />
          </Stack>
        </Box>
      </Stack>
      <Box
        sx={{
          mt: '40px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            cursor: 'pointer'
          }}
          onClick={handleResetFilter}
        >
          <Typography variant="body">
            Reset
          </Typography>
        </Box>
        <BaseButton
          buttonType='primary'
          width='auto'
          onClick={handleClickFilter}
        >
          <Typography
            variant="body"
            color="white"
          >
            Apply
          </Typography>
        </BaseButton>
      </Box>
    </Box>
  )
}

export default MedicationSortForm